import React, { FC } from 'react';
import { Formik, FormikProps } from 'formik';

import { UpdateClientDepartmentInput, UpdateClientLocationInput } from 'api';
import { DepartmentLocationSchema } from 'features/admin/validations';
import { IDepartmentsLocationsOptions } from 'features/admin/types';

import UpdateForm from './UpdateForm';

type IDepartmentLocation = Partial<UpdateClientDepartmentInput | UpdateClientLocationInput>;

interface IProps extends IDepartmentsLocationsOptions {
  item: IDepartmentLocation;
  inputPlaceholderKey: string;
  confirmDeleteKey: string;
}

const Update: FC<IProps> = props => {
  const { updateAsyncMutation, disabledDepartmentStatus, disabledLocationStatus, item, ...rest } =
    props;

  const initialValues = {
    id: item.id,
    title: item.title,
  };

  async function handleSave({ id, title }: IDepartmentLocation) {
    await updateAsyncMutation({ data: { id, title } });
  }

  async function handleDelete(formikProps: FormikProps<IDepartmentLocation>) {
    const { values } = formikProps;
    const { id } = values;
    const data = { id, ...disabledDepartmentStatus, ...disabledLocationStatus };
    await updateAsyncMutation({ data });
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSave}
      validationSchema={DepartmentLocationSchema}
      render={formikProps => (
        <UpdateForm {...rest} item={item} onDelete={() => handleDelete(formikProps)} />
      )}
    />
  );
};

export default Update;
